import { useMemo } from 'react'
import { useApi } from '../useApi'
import {
    GetDeviceDashboardUrlQuerySchema,
    GetDeviceDashboardUrlVariablesSchema,
    type GetDeviceDashboardUrlVariables
} from './metabase_schemas'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useGetMetabaseSignedUrl = (dashboardId: number, params: any, shouldRun: boolean) => {
    const variables = useMemo<GetDeviceDashboardUrlVariables>(
        () => GetDeviceDashboardUrlVariablesSchema.parse({ dashboard_id: dashboardId, params }),
        [dashboardId, params]
    )

    const result = useApi('/platform/get_device_dashboard', variables, GetDeviceDashboardUrlQuerySchema, {
        queryKey: ['platform/get_device_dashboard', variables],
        enabled: !shouldRun
    })

    return {
        data: result.data,
        refetch: result.refetch,
        loading: result.isFetching,
        error: result.error
    }
}
